import React from 'react'
import DashhwmSpecialIndiv from './dashhwmSpecialIndiv';

const WMDemoDashboardInvdiv = () => {
 
    
  return (
    <div>
        <DashhwmSpecialIndiv/>
    </div>
  )
}

export default WMDemoDashboardInvdiv